import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Kiosk from './pages/Kiosk';
import AdminLogin from './pages/AdminLogin';
import AdminApp from './pages/AdminApp';
import SuperAdminApp from './pages/SuperAdminApp';
import Registro from './pages/Registro';
import EmployeeApp from './pages/EmployeeApp';
import Landing from './pages/Landing';
import { Toaster } from './components/ui/sonner';

const Cargando = () => (
  <div className="min-h-screen flex items-center justify-center text-zinc-400">Cargando...</div>
);

const AdminRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Cargando />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role === 'superadmin') return <Navigate to="/superadmin" replace />;
  return <AdminApp />;
};

const SuperAdminRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Cargando />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== 'superadmin') return <Navigate to="/admin" replace />;
  return <SuperAdminApp />;
};

const LoginRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Cargando />;
  if (user) return <Navigate to={user.role === 'superadmin' ? '/superadmin' : '/admin'} replace />;
  return <AdminLogin />;
};

const RegistroRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Cargando />;
  if (user) return <Navigate to={user.role === 'superadmin' ? '/superadmin' : '/admin'} replace />;
  return <Registro />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/kiosko" element={<Kiosk />} />
            <Route path="/app" element={<EmployeeApp />} />
            <Route path="/admin/login" element={<LoginRoute />} />
            <Route path="/registro" element={<RegistroRoute />} />
            <Route path="/admin" element={<AdminRoute />} />
            <Route path="/superadmin" element={<SuperAdminRoute />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
